import React from "react";
import { toast } from "react-toastify";
import { COLORS } from "../assets/theme";
import PageContainer from "../components/PageContainer/PageContainer";
import { useNavigate } from "react-router-dom";
import { useLogout } from "../hooks/auth";
import { ROUTES, combinedRoutes } from "../config/nav";
import { ButtonBase, makeStyles } from "@material-ui/core";
import { QrCodeDeviceMenu, QrCodeScanImage, TruckMenu } from "../assets/images";
import { mq } from "../assets/breakpoints";
import {
  CSSProperties,
  CreateCSSProperties,
} from "@material-ui/core/styles/withStyles";
import { PropsFunc } from "@material-ui/styles";
import useRoleUser from "../hooks/auth/useRoleUser";
import { useGetVehiclesQuery } from "../redux/checklistStoreAPI";

interface Props {}

const flexCenterObj:
  | CSSProperties
  | CreateCSSProperties<{}>
  | PropsFunc<{}, CreateCSSProperties<{}>> = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const useHomePageStyles = makeStyles({
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  btnContainer: {
    flex: 1,
  },
  qrCodeScanImageContainer: {
    ...flexCenterObj,
  },
  divWrapper: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    height: "80vh",
    alignItems: "center",
    "& h5": {
      textAlign: "center",
      fontWeight: 600,
      lineHeight: "1.5",
      maxWidth: 280,
    },
  },
  logoutContainer: {
    position: "fixed",
    bottom: 0,
    left: "50%",
    transform: "translate(-50%, 0)",
    width: "85%",
    maxWidth: 500,
  },
  btnCard: {
    marginTop: "2.4rem",
    display: "block",
    width: "100%",
    height: 80,
    padding: "1.6rem",
    borderRadius: ".8rem",
    border: 0,
    fontWeight: 600,
    overflow: "hidden",
    position: "relative",
    fontSize: "1.5rem",
    "&:hover": {
      opacity: 0.8,
    },
    "&> .textContainer": {
      display: "flex",
      textAlign: "center",
      gap: "1.6rem",
      alignItems: "center",
      "&> .icon": {
        background: "rgba(255,255,255,0.8)",
        padding: "0.8rem 1rem",
        borderRadius: ".4rem",
      },
      "&> .syncicon": {
        background: "#1F354A",
        padding: "0.8rem 1rem",
        borderRadius: ".4rem",
      },
      "&> .syncicondisabled": {
        backgroundColor: "transparent",
        padding: "0.8rem 1rem",
        borderRadius: ".4rem",
      },
    },
  },
  titleMenuWrapper: {
    marginLeft: 56,
    [mq[0]]: {
      marginLeft: 64,
    },
    [mq[3]]: {
      marginLeft: 72,
    },
  },
  titleMenu: {
    marginBottom: 4,
    fontWeight: 700,
    letterSpacing: 0.5,
    marginLeft: 48,
    textAlign: "left",
    fontSize: "1.35rem",
    [mq[1]]: {
      fontSize: "1.75rem",
    },
    [mq[3]]: {
      marginLeft: 72,
    },
  },
  imageIconMenu: {
    width: 64,
    position: "absolute",
    left: 32,
    bottom: -8,
    opacity: "100%",
    // transform: "rotate(25deg)",
    [mq[3]]: {
      left: 32,
    },
  },
  primaryBlueBtn: {
    background: COLORS.gradientBlue_3,
    color: "white",
  },
  walkinBtn: {
    background: COLORS.gradientOrange_1,
    color: "white",
  },
  reserveListBtn: {
    background: COLORS.gradientGreen_2,
    color: "white",
  },
  warehouseListBtn: {
    background: COLORS.gradientAsphalt_2,
    color: "white",
  },
  syncMasterDataBtn: {
    background: COLORS.gradientAsphalt_1,
    color: "white",
    "&:disabled": {
      background: COLORS.gradientGray_1,
    },
  },
  walkinreserveBtn: {
    background: COLORS.gradientPurple_1,
    color: "white",
  },
  logoutBtn: {
    marginTop: "5vh",
    fontWeight: 600,
    fontSize: "1.5rem",
    padding: "1.1rem 0",
    color: COLORS.red_1,
    borderRadius: ".8rem",
    border: `1px solid ${COLORS.red_1}`,
    backgroundColor: "white",
    marginBottom: "1rem",
    width: "100%",
    "&:hover": {
      opacity: 0.7,
    },
  },
});

const HomePage: React.FunctionComponent<Props> = () => {
  const logout = useLogout();
  const classes = useHomePageStyles();
  const navigate = useNavigate();
  const role = useRoleUser();
  // const [vehicleLength, setVehicleLength] = React.useState<number>(10);
  const { data: vehicleList, isFetching } = useGetVehiclesQuery(
    { page: 1, take: 10, dayLeft: 30 },
    { skip: !role || role === "GUEST" }
  );

  // useEffect(() => {
  //   if (vehicleList) {
  //     setVehicleLength(vehicleList.meta.itemCount);
  //   }
  // }, [vehicleList]);

  const renderButtonList = () => {
    switch (role) {
      case "GUEST":
        return (
          <ButtonBase
            title="Pindai QR"
            className={[classes.btnCard, classes.primaryBlueBtn].join(" ")}
            onClick={() => navigate(`${ROUTES.guest}/scan`)}
          >
            <div className={classes.titleMenuWrapper}>
              <h2 className={classes.titleMenu}>Pindai QR</h2>
              {/* <h2 className={classes.titleMenu}>Walk in Approval</h2> */}
            </div>
            <img
              src={QrCodeDeviceMenu}
              alt="icon-menu"
              className={classes.imageIconMenu}
            />
          </ButtonBase>
        );
      case "FSO":
        return (
          <>
            <ButtonBase
              title="Pindai QR"
              className={[classes.btnCard, classes.primaryBlueBtn].join(" ")}
              onClick={() => navigate(`${ROUTES.admin}/scan`)}
            >
              <div className={classes.titleMenuWrapper}>
                <h2 className={classes.titleMenu}>Pindai QR</h2>
                {/* <h2 className={classes.titleMenu}>Walk in Approval</h2> */}
              </div>
              <img
                src={QrCodeDeviceMenu}
                alt="icon-menu"
                className={classes.imageIconMenu}
              />
            </ButtonBase>
            <ButtonBase
              title={`Data Kendaraan (${vehicleList?.entities?.length ?? 0})`}
              className={[classes.btnCard, classes.reserveListBtn].join(" ")}
              onClick={() => navigate(`${combinedRoutes.vehicle_list}`)}
            >
              <div className={classes.titleMenuWrapper}>
                <h2 className={classes.titleMenu}>{`Data Kendaraan (${
                  vehicleList?.meta.itemCount ?? (isFetching ? "..." : 0)
                })`}</h2>
                {/* <h2 className={classes.titleMenu}>Walk in Approval</h2> */}
              </div>
              <img
                src={TruckMenu}
                alt="truck-icon-menu"
                className={classes.imageIconMenu}
              />
            </ButtonBase>
          </>
        );
      default:
        return (
          <div className={classes.btnContainer}>
            <p>Mohon Tunggu , Data sedang dalam proses...</p>
          </div>
        );
    }
  };

  return (
    <PageContainer>
      <div className={classes.divWrapper}>
        <div className={classes.qrCodeScanImageContainer}>
          <img src={QrCodeScanImage} alt="qr-scan" />
        </div>
        <h5>Pindai kode QR Kendaraan untuk melihat Informasi Kendaraan</h5>
        {renderButtonList()}
      </div>
      <div className={classes.logoutContainer}>
        <ButtonBase
          title="Logout"
          className={classes.logoutBtn}
          onClick={() => {
            try {
              logout();
              toast("Logout Berhasil", { type: "success" });
            } catch (error) {
              toast("Logout gagal!", { type: "error" });
              console.error(error);
            }
          }}
        >
          Keluar
        </ButtonBase>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <p style={{ fontWeight: 600, fontSize: "12px", opacity: 0.5 }}>
            © {new Date().getFullYear()} Fajarpaper.  All rights reserved.
          </p>
        </div>
      </div>
    </PageContainer>
  );
};

export default HomePage;
